import { makeStyles, Theme } from '@material-ui/core/styles';

import { basePageStyles } from 'assets/styles/components/Page.styles';
import { baseTabStyles } from 'assets/styles/components/Tab.styles';

const useStyles = makeStyles((theme: Theme) => ({
  ...basePageStyles(theme),
  ...baseTabStyles(theme),
  icon: {
    fontSize: '12em',
  },
}));

export default useStyles;
